module.exports = __webpack_public_path__ + "img/horizontal_7_2_pp2_8017.b3be6c2c.png";